import useApiQuery from 'shared/hooks/use-api-query';
import citiesKeys from '../util/cities-keys';
import {DistanceProps} from '../types';

const useCityDistances = (cityId: string) => {
  return useApiQuery<DistanceProps[]>({
    url: `/distances/cities/${cityId}`,
    queryKey: citiesKeys.distances(cityId),
  });
};

export default useCityDistances;
